export const apiUrl = 'https://api.tacom.srv.br/';
export const praca = 'lza';
export const apiLoginUrl = 'https://apigw.tacom.srv.br/authentication/v1/auth2/login';
export const username = 'lza-citsoa@centralexpresso.com';
export const password = 'jnw$w7Psw4';

export const versaoSoftware = '4.4.11';
export const idioma = 'pt_BR'

export default {
}